// PostHog solo se carga si el usuario acepta las cookies analíticas.
let loaded = false;

export function loadAnalytics() {
  if (loaded || window.posthog) return;
  loaded = true;
  const script = document.createElement("script");
  script.src = "https://ap.emergent.sh/static/array.js";
  script.type = "text/javascript";
  script.crossOrigin = "anonymous";
  script.async = true;
  script.onload = () => {
    if (window.posthog) {
      window.posthog.init("phc_DbsPb39SRc8z3EiQ6Dhj6ikv4H4rTKcht9d4sZSesceP", {
        api_host: "https://ap.emergent.sh",
        person_profiles: "identified_only",
        session_recording: {
          recordCrossOriginIframes: true,
          capturePerformance: false,
        },
      });
    }
  };
  document.head.appendChild(script);
}
